import './Footer.scss';
import Facebook from '../../assets/icons/socials/Facebook';
import Github from '../../assets/icons/socials/Github';
import Linkedin from '../../assets/icons/socials/Linkedin';
import Youtube from '../../assets/icons/socials/Youtube';
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer id="contacts">
        <div className="content">
            <Logo/>
            <nav className="item-grid navigation">
                <a href="https://neuro-research.ai/quantum/en#services">Services</a>
                <Link className='menu_item' to={'/products'}>Products</Link>
                <a href="https://neuro-research.ai/quantum/en#team">About Us</a>
                <a href="https://neuro-research.ai/contact-us/en">Contacts</a>
            </nav>
            <div className="item-grid additional">
                <span>+1 438 347 46 06</span>
                <span>info@neuro-research.ai</span>
                <span>+380 97 767 65 56</span>
                <span className="socials">
                    <a href="https://www.facebook.com/neuro.research.ai.quantum"  target="_blank" rel="noreferrer noopener"><Facebook/></a>
                    <a href="https://www.linkedin.com/company/neuro-research-ai-quantum"  target="_blank" rel="noreferrer noopener"><Linkedin/></a>
                    <a href="https://www.youtube.com/@neuro-research-ai-quantum"  target="_blank" rel="noreferrer noopener"><Youtube/></a>
                    <a href="https://github.com/neuro-research-ai-quantum"  target="_blank" rel="noreferrer noopener"><Github/></a>
                </span>
            </div>
        </div>
        <div className="copywrite">
            <div>© RAINLAB Quantum 2023. All Rights Reserved</div>
            <div className="additionalLinks"><a href="https://neuro-research.ai/legal/privacy-policy/en">Privacy Policy</a></div>
        </div>
    </footer>
  )
}

export default Footer